import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import { AbstractDocumentViewComponent } from '../abstract-document-view/abstract-document-view.component';
import {DomSanitizer} from '@angular/platform-browser';
import {FidjiDocumentActionNatifService, FidjiNatifLibraryService} from '@immanens-com/fidji-api-module';
import {DocumentControllerService} from '../../../core/services/document/document-controller.service';
import {UserControllerService} from '../../../core/services/user/user-controller.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {loaderAnimation, thumbAnimation} from '../../animations/document-thumb.animation';

@Component({
  selector: 'app-document-thumbnail',
  templateUrl: './document-thumbnail.component.html',
  styleUrls: ['./document-thumbnail.component.scss'],
  animations: [thumbAnimation, loaderAnimation],
  encapsulation : ViewEncapsulation.None // otherwise it seems we have conflicts with bootstrap
})
export class DocumentThumbnailComponent extends AbstractDocumentViewComponent implements OnInit {

  @Input() active = true;

  protected coverSize = 'small';

  inEdit = true;

  _isDeletable = false;
  @Input() set deletable(deletable: boolean) {
    this._isDeletable = deletable;
    this.inEdit = deletable;
    this.inEditStateChange.emit(deletable);
  }

  @Output() inEditStateChange = new EventEmitter();
  @Output() clickButton = new EventEmitter();
  @Output() clickCover = new EventEmitter();

  constructor(protected libraryService: FidjiNatifLibraryService,
              protected documentAction: FidjiDocumentActionNatifService,
              protected sanitizer: DomSanitizer,
              protected documentCtrl: DocumentControllerService,
              protected userControllerService: UserControllerService) {
    super(libraryService, documentAction, sanitizer, documentCtrl, userControllerService);
  }

  public onClickCover() {
    this.clickCover.emit(true);
  }

  public onClickButton() {
    this.clickButton.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/document-view/document-thumbnail/document-thumbnail.component.ts